// Component Name:  Location component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date:
// Description: This component is display all the location.
// Dependencies: React, Spinner, API layer to fetch location and image
// Interfaces: Accepts props including
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [] created layout to display the locations and the map
// [] Integrated API Layer to fetch the locations under the host
// [] Created cards to display each location; on hover, shows charge status details
// [] Added Edit button for each location card

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import MarkerImg from "../../assets/images/LK_Icons/LK__Destination Pin A.svg";
import chargeIcon from "../../assets/images/infobar/clusterIcon1.png";
import companyIcon from "../../assets/images/infobar/companyIcon.png";
import LKEditImg from "../../assets/images/LK_Icons/LK__Edit Content.svg";
import LKEVChargerImg from "../../assets/images/LK_Icons/LK__EV charger_blue.svg";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Col, Container, FormGroup, Input, Row } from "reactstrap";
import {
  GoogleMap,
  Marker,
  MarkerClusterer,
  useJsApiLoader,
} from "@react-google-maps/api";
import { connect } from "react-redux";
import { locationSelected } from "../../store/locations/actions";
import { INUSE_CHARGER_STATUS } from "../Utility/Constants";
import { loadImages } from "../../api/utils/loadImages";
import Spinner from "../Utility/Spinner";
import {
  lkBlue2,
  lkBrandBlue,
  lkGray,
  lkGray2,
  lkGreen2,
  lkRed2,
  lkWhite,
} from "../Utility/styleComponents";
import { loadLocation } from "../../api/utils/loadLocations";
import {
  loadChargerRecentStatus,
  loadChargersWithStatus,
} from "../../api/utils/loadChargerStatus";
import LKCompletedImg from "../../assets/images/LK_Icons/LK__Completed.svg";
import LKErrorImg from "../../assets/images/LK_Icons/LK__Error.svg";
import LKOfflineImg from "../../assets/images/LK_Icons/LK_Internet Disconnected.svg";
import LKRadioBtnCheckImg from "../../assets/images/LK_Icons/LK__Radio Button Check.svg";
import LKArrowDownImg from "../../assets/images/LK_Icons/LK_Arrow Down.svg";
import LKProjectImg from "../../assets/images/LK_Icons/LK__Project.svg";
import LKSearchImg from "../../assets/images/LK_Icons/LK_Search.svg";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";
import LKRestroomImg from "../../assets/images/lk_restroom_icon.png";
import LKRestaurantImg from "../../assets/images/lk_restaurant_icon.png";
import LKParkingImg from "../../assets/images/lk_parking_icon.png";
import { isTechnician } from "../Authentication/userMetaData";

const containerStyle = {
  width: "101.5%",
  height: "100%",
};
const libraries = ["places"];
const googleAPIKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
const Locations = (props) => {
  // console.log("google props: ",props);

  const { locationIds, chargerIds } = props;
  const chargersDataRef = useRef([]);
  const [prevChargerStatus, setPrevChargerStatus] = useState({});
  const breadcrumbItems = [
    { title: "Charger Management System", link: "#" },
    { title: "Locations", link: "#" },
  ];
  const [center, setCenter] = useState({ lat: 28.46175, lng: 77.500485 });
  const [selectedCard, setSelectedCard] = useState("");
  const [chargersDisplay, setChargersDisplay] = useState("");
  const [cardData, setCardData] = useState([]);
  const [map, setMap] = useState(null);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const sectionRefs = useRef([]);
  const [imageMap, setImageMap] = useState({});
  const [locationData, setLocationData] = useState([]);
  const [filterLocationData, setFilterLocationData] = useState([]);
  const [searchBy, setSearchBy] = useState("");
  //style for custer marker
  const clusterStyles = [
    {
      textColor: lkWhite,
      url: chargeIcon, // URL to your icon image
      height: 60,
      width: 60,
    },
    {
      textColor: lkWhite,
      url: chargeIcon,
      height: 100,
      width: 100,
    },
    {
      textColor: lkWhite,
      url: chargeIcon,
      height: 140,
      width: 140,
    },
  ];

  // auto scroll to item onClick Marker
  const scrollToSection = (scrollToIndex) => {
    if (sectionRefs.current.length > 0) {
      if (scrollToIndex !== -1 && sectionRefs.current[scrollToIndex]) {
        sectionRefs.current[scrollToIndex].scrollIntoView({
          // top:100,
          behavior: "auto",
          block: "start",
        });
      }
    }
  };

  // refers to the map on google map load
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleAPIKey,
    libraries,
  });

  const onMapLoad = useCallback(
    (map) => {
      setMap(map);
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(center);
      // map.fitBounds(bounds);
    },
    [center]
  );

  const onUnmount = () => {
    setMap(null);
  };
  useEffect(() => {
    handleLoadLocations();
  }, [locationIds]);
  // load the images map for each location images
  const handleLoadLocations = async () => {
    try {
      setLoadingLocations(true);
      const data = await loadLocation(locationIds, false);
      setLocationData(data);
      setLoadingLocations(false);
    } catch (e) {
      console.log("Error Images Data: ", e);
    }
  };

  useEffect(() => {
    if (chargerIds?.length > 0) {
      handleGetChargerData();
    }
    const intervalId = setInterval(() => {
      handleUpdateRecentStatus();
    }, 6000); // Repeat every 6000ms (6 seconds)
    return () => {
      clearInterval(intervalId);
    };
  }, [chargerIds]);

  const handleGetChargerData = async () => {
    try {
      const { formatData, status } = await loadChargersWithStatus(
        chargerIds,
        prevChargerStatus
      );
      const { anyStatusChanged, recentStatusUpdate, previousStatus } =
        await loadChargerRecentStatus(formatData, status);
      if (recentStatusUpdate?.length > 0) {
        chargersDataRef.current = recentStatusUpdate;
      }
    } catch (err) {
      console.log("Err fetching the chargers data: ");
    }
  };
  const handleUpdateRecentStatus = async () => {
    try {
      const { anyStatusChanged, recentStatusUpdate, previousStatus } =
        await loadChargerRecentStatus(
          chargersDataRef.current,
          prevChargerStatus
        );

      if (anyStatusChanged || chargersDataRef.current?.length === 0) {
        // Update main data
        chargersDataRef.current = recentStatusUpdate;
        setPrevChargerStatus(previousStatus);
      }
    } catch (err) {
      console.log("Err fetching the chargers data: ", err);
    }
  };
  // cal the number of chargers(Offline,charging, Available and faulted)
  useEffect(() => {
    let timeout;
    if (locationData?.length > 0) {
      handleLoadImages(locationData);

      setLoadingLocations(false);
      const data = locationData?.map((item) => {
        const {
          id,
          imageId,
          latitude,
          longitude,
          name,
          visibility,
          amenities,
        } = item;

        const chargerAssociatedWithLocation = chargersDataRef?.current?.filter(
          (item) => item?.locationId === id
        );
        const offlineCharger = chargersDataRef?.current?.filter(
          (item) =>
            item?.status?.toLowerCase() === "offline" && item?.locationId === id
        );
        const inUseCharger = chargersDataRef?.current?.filter(
          (item) =>
            INUSE_CHARGER_STATUS?.includes(item?.status?.toLowerCase()) &&
            item?.locationId === id
        );
        const idleCharger = chargersDataRef?.current?.filter(
          (item) =>
            item?.status?.toLowerCase() === "available" &&
            item?.locationId === id
        );
        const faultedChargers =
          chargerAssociatedWithLocation?.length -
          (idleCharger?.length + inUseCharger?.length + offlineCharger?.length);
        return {
          id: id,
          key: id,
          title: name,
          description: `Chargers : ${chargerAssociatedWithLocation?.length}`,
          sessions: 0,
          lat: Number(latitude),
          lng: Number(longitude),
          idle: `${idleCharger?.length}`,
          InUse: `${inUseCharger?.length}`,
          Faulted: `${faultedChargers}`,
          Offline: `${offlineCharger?.length}`,
          imageId: imageId,
          // amenities: amenities?.length > 0 ? amenities?.join(", ") : "No amenities",
          amenities: amenities,
        };
      });

      setCardData(data);
      setFilterLocationData(data);
      // sectionRefs.current = data.map(() => React.createRef());
      setCenter({
        lat: Number(locationData[0]?.latitude),
        lng: Number(locationData[0]?.longitude),
      });
    }
    return () => clearTimeout(timeout);
  }, [locationData, chargersDataRef?.current]);

  useEffect(() => {
    const searchByFilter = cardData?.filter((item) => {
      return item?.title?.toLowerCase()?.includes(searchBy?.toLowerCase());
    });
    console.log("search by filter: ", searchByFilter);
    setFilterLocationData(searchByFilter);
  }, [searchBy]);

  // load the images map for each location images
  const handleLoadImages = async (locationData) => {
    try {
      const imagesdata = await loadImages(locationData);
      setImageMap(imagesdata);
    } catch (e) {
      console.log("Error Images Data: ", e);
    }
  };
  // on Click edit, move to add location with pre-populated data
  const handleEditLocation = (locationId) => {
    props.locationSelected(locationId);
    props.history.push("/cms-add-locations");
  };

  // on Click card, move to dashboard with the location Id selected
  const selectLocation = (locationId) => {
    props.locationSelected(locationId);
    props.history.push("/dashboard");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Locations" breadcrumbItems={breadcrumbItems} />
          <div style={styles.container}>
            {/* charger station list */}
            <div style={styles.cardContainer} className="col-3">
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  backgroundColor: "#FFF",
                  padding: "10px 0",
                }}
              >
                <div className="input-group ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <img
                        src={LKSearchImg}
                        alt="searchImg"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by location"
                    value={searchBy}
                    onChange={(e) => setSearchBy(e.target.value)}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={LKCloseImg}
                        alt="closeImg"
                        style={{
                          width: "15px",
                          height: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => setSearchBy("")}
                      />
                    </span>
                  </div>
                </div>
              </div>

              {loadingLocations ? (
                <div style={styles.loaderContainer}>
                  <Spinner />
                </div>
              ) : filterLocationData?.length === 0 ? (
                !isTechnician(props?.user) ? (
                  <Link to="/cms-add-locations" className="mt-6">
                    + Add locations
                  </Link>
                ) : (
                  <span>No Locations</span>
                )
              ) : (
                <div>
                  <div>
                    {filterLocationData.map((card, index) => (
                      <div
                        className="text-dark"
                        style={{ position: "relative", cursor: "pointer" }}
                        onClick={() => !isTechnician(props?.user) && selectLocation(card?.id)}
                        key={card?.id}
                      >
                        <div
                          key={card.id}
                          style={
                            selectedCard === card.key
                              ? styles.selectedCard
                              : styles.card
                          }
                          // ref={sectionRefs.current[index]}
                          ref={(el) => (sectionRefs.current[index] = el)}
                          onMouseOver={() => setChargersDisplay(card.key)}
                          onMouseLeave={() => setChargersDisplay("")}
                        >
                          <div style={styles.cardHeadingContainer}>
                            <div style={styles.cardHeading1}>
                              <img
                                src={imageMap[card.imageId] || LKProjectImg}
                                style={styles.companyIcon}
                              />
                              <h5
                                style={{
                                  color:
                                    selectedCard === card.key
                                      ? lkBrandBlue
                                      : chargersDisplay === card.key &&
                                        lkBrandBlue,
                                  textDecoration:
                                    chargersDisplay === card.key
                                      ? "underline"
                                      : "none",
                                  textDecorationColor:
                                    chargersDisplay === card.key
                                      ? lkBrandBlue
                                      : "none",
                                  margin: "0",
                                  padding: "0",
                                }}
                              >
                                {card.title}
                              </h5>
                            </div>
                          </div>

                          <span
                            className="d-flex align-items-center gap-8 ml-2"
                            style={{ fontSize: "17px" }}
                          >
                            <img
                              src={LKEVChargerImg}
                              alt="charger"
                              style={{ width: "18px", height: "18px" }}
                            />
                            <span className="px-2" style={{ width: "85%" }}>
                              {" "}
                              {card.description}
                            </span>
                            <img
                              src={LKArrowDownImg}
                              alt="charger"
                              style={{ width: "10px", height: "10px" }}
                            />
                          </span>

                          {/* charger status */}
                          <div
                            className="pl-2 mt-1 ml-4 "
                            style={{
                              display:
                                chargersDisplay === card.key ? "block" : "none",
                            }}
                          >
                            {/* Idle */}
                            <div className="d-flex align-items-start">
                              <span
                                className="d-flex align-items-center"
                                style={{ minWidth: "70px" }}
                              >
                                <img
                                  src={LKRadioBtnCheckImg}
                                  alt="LKRadioBtnCheckImg"
                                  style={styles.imgStyle}
                                />
                                Idle
                              </span>
                              <b style={styles.colonStyle}>:</b>
                              <span style={styles.valueStyle}>{card.idle}</span>
                            </div>

                            {/* InUse */}
                            <div className="d-flex align-items-start">
                              <span
                                className="d-flex align-items-center"
                                style={{ minWidth: "70px" }}
                              >
                                <img
                                  src={LKCompletedImg}
                                  alt="LKCompletedImg"
                                  style={styles.imgStyle}
                                />
                                InUse
                              </span>
                              <b style={styles.colonStyle}>:</b>
                              <span style={styles.valueStyle}>
                                {" "}
                                {card.InUse}
                              </span>
                            </div>
                            {/*Faulted */}
                            <div className="d-flex align-items-start">
                              <span
                                className="d-flex align-items-center"
                                style={{ minWidth: "70px" }}
                              >
                                <img
                                  src={LKErrorImg}
                                  alt="LKErrorImg"
                                  style={styles.imgStyle}
                                />
                                Faulted
                              </span>
                              <b style={styles.colonStyle}>:</b>
                              <span style={styles.valueStyle}>
                                {" "}
                                {card.Faulted}
                              </span>
                            </div>
                            {/* Offline */}
                            <div className="d-flex align-items-start">
                              <span
                                className="d-flex align-items-center"
                                style={{ minWidth: "70px" }}
                              >
                                <img
                                  src={LKOfflineImg}
                                  alt="LKOfflineImg"
                                  style={styles.imgStyle}
                                />
                                Offline
                              </span>
                              <b style={styles.colonStyle}>:</b>
                              <span style={styles.valueStyle}>
                                {" "}
                                {card.Offline}
                              </span>
                            </div>
                          </div>

                          {/* Sessions */}
                          <span
                            className="d-flex align-items-center gap-8 mt-1 ml-2"
                            style={{ fontSize: "17px" }}
                          >
                            <i
                              className="ri-stack-line"
                              style={{ color: "#005C8E" }}
                            ></i>
                            <span className="px-2">
                              Sessions : {card.sessions}
                            </span>
                          </span>
                          {/* Amenities */}
                          <span
                            className="d-flex align-items-start gap-8 mt-1"
                            style={{ fontSize: "17px", textDecoration: "none" }}
                          >
                            {/* <i className="ri-blaze-line" style={{ color: "#005C8E" }}></i> */}
                            <span className="px-2">Amenities: </span>
                            <span>
                              {card?.amenities?.map((item) => {
                                if (item === "Parking")
                                  return (
                                    <img
                                      src={LKParkingImg}
                                      style={{
                                        width: "25px",
                                        height: "25px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  );
                                if (item === "Restaurant")
                                  return (
                                    <img
                                      src={LKRestaurantImg}
                                      style={{
                                        width: "25px",
                                        height: "25px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  );
                                if (item === "Restroom")
                                  return (
                                    <img
                                      src={LKRestroomImg}
                                      style={{
                                        width: "25px",
                                        height: "25px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  );
                              })}
                            </span>
                          </span>
                        </div>
                        {!isTechnician(props?.user) && (
                          <div style={styles.editContainer}>
                            <img
                              src={LKEditImg}
                              alt="editImg"
                              style={styles.editIcon}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditLocation(card?.id);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {/* Map container */}
            <div style={styles.map} className="col-9">
              {isLoaded ? (
                <GoogleMap
                  google={window.google}
                  mapContainerStyle={containerStyle}
                  center={center}
                  onLoad={onMapLoad}
                  onUnmount={onUnmount}
                  zoom={4}
                >
                  {/* <MarkerClusterer gridSize={10} maxZoom={20} styles={clusterStyles}> */}
                  {
                    // (clusterer) =>
                    cardData.map((card, index) => (
                      <Marker
                        key={index}
                        position={{ lat: card.lat, lng: card.lng }}
                        title={card.title}
                        name={card.title}
                        // clusterer={clusterer}
                        onClick={() => {
                          setSelectedCard(card.key);
                          setCenter({ lat: card.lat, lng: card.lng });
                          scrollToSection(index);
                        }}
                        icon={{
                          url: MarkerImg,
                          scaledSize: new window.google.maps.Size(30, 30),
                        }}
                      />
                    ))
                  }
                  {/* </MarkerClusterer> */}
                </GoogleMap>
              ) : (
                <div style={styles.loaderContainer}>
                  <Spinner />
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const styles = {
  container: { display: "flex", height: "80vh" },
  cardContainer: {
    // padding: "10px",
    boxSizing: "border-box",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #dee2e6",
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#005C8E #f0f0f0",
  },
  card: {
    marginBottom: "20px",
    padding: "10px",
    backgroundColor: "#ffffff",
    boxShadow: "0 0 5px rgba(0,0,0,0.3)",
    borderRadius: "5px",
  },
  selectedCard: {
    marginBottom: "20px",
    padding: "10px",
    backgroundColor: "#efefef",
    boxShadow: "0 0 5px rgba(0,0,0,0.4)",
    borderRadius: "5px",
  },
  cardHeadingContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "6px",
    marginBottom: "10px",
  },
  cardHeading1: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "6px",
  },
  companyIcon: { width: "38px", height: "38px", borderRadius: "50%" },
  loaderContainer: { height: "250px" },
  editContainer: { position: "absolute", top: "8px", right: "8px" },
  editIcon: {
    width: "25px",
    height: "25px",
    cursor: "pointer",
    padding: "5px",
    backgroundColor: "#ffffff",
  },
  colonStyle: { width: "10px", textAlign: "center" },
  valueStyle: { marginLeft: "8px", flex: 1 },
  imgStyle: { width: "14px", height: "14px", marginRight: "6px" },
};
const mapStateToProps = (state) => ({
  user: state.Login.user,
  locationData: state?.LocationManagement?.locationData,
  locationIds: state?.LocationManagement?.locationIds,
  chargerIds: state?.ChargerManagement?.chargerIds,
});
const mapDispatchToProps = (dispatch) => ({
  locationSelected: (payload) => dispatch(locationSelected(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Locations);
